import { images } from "../../assets/images";


export const buildAssessments = {
  primary: {
    id: "question-paper-generator",
    title: "Question Paper Generator",
    description: "Full exam papers with blue-prints",
    iconSrc: images.build.primary,
    actionLabel: "START",
    href: "#question-paper-generator"
  },
  secondary: [
  {
    id: "section-builder",
    title: "Section Builder",
    description: "Organize questions into exam sections",
    iconSrc: images.build.section,
    href: "#section-builder"
  },
  {
    id: "difficulty-balancer",
    title: "Difficulty Balancer",
    description: "Balance easy, medium, and hard questions",
    iconSrc: images.build.difficulty,
    href: "#difficulty-balancer"
  }],

  showPreviewBadge: true
};